/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q11Inputs */

const et_faq_q11 = /** @type {(inputs: Faq_Q11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kes pakub Eestis tulemuspõhist SEO ja veebiarenduse teenust?`)
};

const en_faq_q11 = /** @type {(inputs: Faq_Q11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who offers results-driven SEO and web development services in Estonia?`)
};

/**
* | output |
* | --- |
* | "Who offers results-driven SEO and web development services in Estonia?" |
*
* @param {Faq_Q11Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q11 = /** @type {((inputs?: Faq_Q11Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q11Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q11(inputs)
	return en_faq_q11(inputs)
});